/**
 * Normalizes PAN / DOB / Aadhaar from login profile, product onboarding Redux, or API payloads.
 * Different products use pan vs panNumber; APIs may use aadharNumber vs aadhaarNumber / dob vs dateOfBirth.
 */
const firstNonEmpty = (...values) => {
  for (const value of values) {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      return value;
    }
  }
  return "";
};

export const pickKycFromLoginProfile = (loginProfile = {}) => ({
  panNumber: firstNonEmpty(
    loginProfile.pan,
    loginProfile.panNumber,
    loginProfile.pancardNumber,
  ),
  dateOfBirth: firstNonEmpty(loginProfile.dob, loginProfile.dateOfBirth),
  aadharNumber: firstNonEmpty(
    loginProfile.aadharNumber,
    loginProfile.aadhaarNumber,
  ),
});

export const pickKycFromOnboarding = (onboarding = {}) => ({
  panNumber: firstNonEmpty(
    onboarding.panNumber,
    onboarding.pan,
    onboarding.pancardNumber,
  ),
  dateOfBirth: firstNonEmpty(onboarding.dateOfBirth, onboarding.dob),
  aadharNumber: firstNonEmpty(
    onboarding.aadharNumber,
    onboarding.aadhaarNumber,
  ),
});

/** Merge API/onboarding values with login profile; onboarding wins, then login, then existing form. */
export const resolveCkycFormData = (
  loginProfile = {},
  onboarding = {},
  prevFormData = {},
) => {
  const fromLogin = pickKycFromLoginProfile(loginProfile);
  const fromOnboarding = pickKycFromOnboarding(onboarding);

  return {
    panNumber: firstNonEmpty(
      fromOnboarding.panNumber,
      fromLogin.panNumber,
      prevFormData.panNumber,
    ),
    dateOfBirth: firstNonEmpty(
      fromOnboarding.dateOfBirth,
      fromLogin.dateOfBirth,
      prevFormData.dateOfBirth,
    ),
    aadharNumber: firstNonEmpty(
      fromOnboarding.aadharNumber,
      fromLogin.aadharNumber,
      prevFormData.aadharNumber,
    ),
  };
};

/** For onboarding sagas after detail API — same merge order as the form. */
export const mergeKycWithLoginProfile = (payload = {}, loginProfile = {}) =>
  resolveCkycFormData(loginProfile, payload);
